/** @jsx jsx */
/** @jsxfrag */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { N0, N40A, N50A } from '@atlaskit/theme/colors';
var imageStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&&': {
    maxHeight: '24px',
    maxWidth: '26px',
    flexShrink: 0,
    lineHeight: 1,
    margin: 'auto'
  }
});
var appLogoStyles = css({
  height: '32px',
  width: '32px',
  boxSizing: 'border-box',
  backgroundColor: "var(--ds-background-neutral, ".concat(N0, ")"),
  borderRadius: '8px',
  display: 'flex',
  overflow: 'hidden',
  boxShadow: "var(--ds-shadow-raised, ".concat("0 1px 1px ".concat(N50A, ", 0 0 1px 1px ").concat(N40A), ")")
});
var tblzSwitcherExperimentIconStyles = css({
  border: "1px solid ".concat("var(--ds-shadow-overflow-spread, #091E4224)"),
  boxShadow: 'none',
  backgroundColor: 'transparent'
});
export var AppLogo = function AppLogo(_ref) {
  var src = _ref.src,
    tblzSwitcherRoleBasedExperimentCohort = _ref.tblzSwitcherRoleBasedExperimentCohort;
  return jsx("span", {
    css: [appLogoStyles, tblzSwitcherRoleBasedExperimentCohort === 'experiment' ? tblzSwitcherExperimentIconStyles : null]
  }, jsx("img", {
    css: imageStyles,
    src: src
  }));
};
AppLogo.propTypes = {
  src: PropTypes.string.isRequired
};